import React from 'react';
import kulConfig from '@com/core/kul/kulConfig';

// Includes both simple and creative icons
export type TIconName =
    | 'amex'
    | 'returns'
    | 'arrow-right'
    | 'back'
    | 'back-black'
    | 'bell-red'
    | 'bell'
    | 'box'
    | 'call'
    | 'cart'
    | 'cart-black'
    | 'cash-red'
    | 'cash'
    | 'check'
    | 'check-grey'
    | 'check-mabel'
    | 'close'
    | 'close-black'
    | 'coupon'
    | 'credit-card-red'
    | 'credit-card'
    | 'deal-lock'
    | 'deliver'
    | 'down-arrow'
    | 'down-arrow-black'
    | 'edit'
    | 'express'
    | 'express-ar'
    | 'express-en'
    | 'eye-off'
    | 'eye'
    | 'easy-returns'
    | 'filter'
    | 'filter-black'
    | 'fire'
    | 'flag'
    | 'gift'
    | 'grid'
    | 'heart'
    | 'home'
    | 'info'
    | 'kul-cards'
    | 'kul-credits'
    | 'list'
    | 'locate'
    | 'location-pin'
    | 'location'
    | 'mastercard'
    | 'menu'
    | 'minus'
    | 'minus-black'
    | 'minus-circle-black'
    | 'more'
    | 'orders'
    | 'non-returnable'
    | 'padlock'
    | 'plus'
    | 'plus-black'
    | 'plus-circle-black'
    | 'power'
    | 'question'
    | 'remove'
    | 'remove-grey'
    | 'returnable'
    | 'right-arrow'
    | 'right-arrow-black-en'
    | 'right-arrow-black-ar'
    | 'sale-tag'
    | 'search'
    | 'search-dark'
    | 'secure'
    | 'shield'
    | 'sign-in'
    | 'sign-up'
    | 'soldby'
    | 'sort'
    | 'sort-black'
    | 'star'
    | 'store'
    | 'success'
    | 'tags'
    | 'thumbs-up'
    | 'truck'
    | 'freeshipping'
    | 'up-arrow'
    | 'up-left-arrow'
    | 'up'
    | 'user'
    | 'visa'
    | 'wishlist'
    | 'wishlist-black'
    | 'world'
    | 'facebook'
    | 'twitter'
    | 'instagram'
    | 'linkedin'
    | 'x-octagon';

type TProps = {
    name: TIconName;
    imgBase?: string;
    path?: string;
    extension?: string;
    alt?: string;
};

const Icon = (props: TProps): JSX.Element => {
    const {
        name,
        imgBase = kulConfig.urls.imgBase,
        path = 'icons',
        extension = 'svg',
        alt = name,
        ...restOfTheProps
    } = props;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <img src={`${imgBase}${path}/${name}.${extension}`} alt={alt} {...restOfTheProps} />;
};

export default Icon;
